export const AjaxRequest = {
	post: async (body, sendCredentials = true) => {
		const response = await fetch(
			'/wp-admin/admin-ajax.php',
			{
				credentials: sendCredentials ? 'same-origin' : 'omit',
				body: new URLSearchParams(body),
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache' }
			}
		);
		if (!response.ok) {
			throw response;
		}
		return response;
	},

	get: async (params, sendCredentials = true) => {
		const response = await fetch(
			`/wp-admin/admin-ajax.php?${new URLSearchParams(params).toString()}`,
			{
				credentials: sendCredentials ? 'same-origin' : 'omit',
			}
		);
		if (!response.ok) {
			throw response;
		}
		return response;
	}
}
